var flashcardSlide = function(global) {
    // clear it out
    var frame = $(global.flashcard).find('.image-column .image-frame');
    frame.html('');

    var slide = global.flashcards[global.currentSlide];

    if (typeof slide.image_url !== 'undefined') {
        var str = '<img class="slide-image" src="'+ slide.image_url+'" />';
        var image = $.parseHTML(str);
        frame.append(image);
    }

    var answerChoice = 'choice_' + slide.correct_choice;
    var answer = slide[answerChoice];

    $(global.flashcard).find('.exam-title').html(slide.question);
    $(global.flashcard).find('.answer').html('Answer: ' + answer);

    $(global.flashcard).find('.explanation').html(slide.explanation);
    // set it as seen
    slide.seen = true;
}


module.exports = flashcardSlide;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_slide.js
// module id = 314
// module chunks = 0